import type { UUID } from 'crypto'

export enum AlertStatus {
  UNREAD = 'unread',
  READ = 'read',
  ARCHIVED = 'archived',
}

export const alertStatusLabels: Record<AlertStatus, string> = {
  [AlertStatus.UNREAD]: 'Ongelezen',
  [AlertStatus.READ]: 'Gelezen',
  [AlertStatus.ARCHIVED]: 'Gearchiveerd',
}

export type Alert = {
  id: UUID
  customerId: UUID
  status: AlertStatus
  title: string
  description: string | null
  url: string | null
  emailSentAt: string | null
  createdAt: string
  updatedAt: string
}
